import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Info from '../views/home/info'
/*import { checkPermission } from '../assets/js/util'*/
import Main from '@/views/common/Home'
Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: '/Home'
    }, {
        path: '/',
        name: 'Main',
        component: Main,
        meta: {
            title: '系统首页'
        },
        children: [{
                path: '/Home',
                name: 'Home',
                component: Home,
                meta: {
                    title: '系统首页'
                },
            },
            {
                path: '/instrument/instrument',
                name: 'instrument',
                component: () => import('../views/instrument/instrument.vue'),
                meta: {
                    title: '皮肤科消费表'
                },
            },
            {
                path: '/instrument/add',
                name: 'instrumentAdd',
                component: () => import('../views/instrument/add.vue'),
                meta: {
                    title: ''
                },
            },
            {
                path: '/list/list',
                name: 'list',
                component: () => import('../views/list/list.vue'),
                meta: {
                    title: '消费表历史数据'
                },
            },
            {
                path: '/log/log',
                name: 'log',
                component: () => import('../views/log/log.vue'),
                meta: {
                    title: '消费表日志'
                },
            },
            {
                path: '/outpatients/outpatients',
                name: 'outpatients',
                component: () => import('../views/outpatients/outpatients.vue'),
                meta: {
                    title: '门诊日志'
                },
            },
            {
                path: '/buckle/buckle',
                name: 'buckle',
                component: () => import('../views/buckle/buckle.vue'),
                meta: {
                    title: '划扣信息列表'
                },
            },
            {
                path: '/skinMedical/medical',
                name: 'skinMedical',
                component: () => import('../views/skinMedical/medical.vue'),
                meta: {
                    title: '中胚层类型电子病历'
                },
            },
            {
                path: '/medical/medical',
                name: 'medical',
                component: () => import('../views/medical/medical.vue'),
                meta: {
                    title: '激光类型电子病历'
                },
            },
            {
                path: '/injectMedical/medical',
                name: 'injectMedical',
                component: () => import('../views/injectMedical/medical.vue'),
                meta: {
                    title: '注射类型电子病历'
                },
            },
            {
                path: '/registrationForm/registration',
                name: 'registration',
                component: () => import('../views/registrationForm/registration.vue'),
                meta: {
                    title: '美容外科手术表'
                },
            },
            {
                path: '/registrationForm/injection',
                name: 'injection',
                component: () => import('../views/registrationForm/injection.vue'),
                meta: {
                    title: '美容外科耗材表'
                },
            },
            {
                path: '/registrationForm/logData',
                name: 'registrationlogData',
                component: () => import('../views/registrationForm/logData.vue'),
                meta: {
                    title: '美容外科登记表日志'
                },
            },
            {
                path: '/observation/observation',
                name: 'observation',
                component: () => import('../views/observation/observation.vue'),
                meta: {
                    title: '留观管理'
                },
            },

            {
                path: '/microsurgery/dermatology',
                name: 'dermatology',
                component: () => import('../views/microsurgery/dermatology.vue'),
                meta: {
                    title: '注射微整科登记表'
                },
            },
            {
                path: '/microsurgery/consumables',
                name: 'consumables',
                component: () => import('../views/microsurgery/consumables.vue'),
                meta: {
                    title: '注射微整科耗材表'
                },
            },
            {
                path: '/microsurgery/logData',
                name: 'logData',
                component: () => import('../views/microsurgery/logData.vue'),
                meta: {
                    title: '注射微整科登记表日志'
                },
            },

            {
                path: '/identity/identity',
                name: 'identity',
                component: () => import('../views/identity/identity.vue'),
                meta: {
                    title: '身份配置',
                    keepAlive: true
                },
            },
            {
                path: '/class/class',
                name: 'class',
                component: () => import('../views/class/class.vue'),
                meta: {
                    title: '职级配置'
                },
            },
            {
                path: '/configuration/configuration',
                name: 'configuration',
                component: () => import('../views/configuration/configuration.vue'),
                meta: {
                    title: '仪器配置',
                    keepAlive: true
                },
            },
            {
                path: '/consumable/consumable',
                name: 'consumable',
                component: () => import('../views/consumable/consumable.vue'),
                meta: {
                    title: '耗材配置'
                },
            },
            {
                path: '/diagnosisList/diagnosis',
                name: 'diagnosis',
                component: () => import('../views/diagnosisList/diagnosis.vue'),
                meta: {
                    title: '病历模板'
                },
            },
            {
                path: '/setInject/setSurgical',
                name: 'setSurgical',
                component: () => import('../views/setInject/setSurgical.vue'),
                meta: {
                    title: '美容外科手术表设置'
                },
            },
            {
                path: '/setInject/setProduction',
                name: 'injectProduction',
                component: () => import('../views/setInject/setProduction.vue'),
                meta: {
                    title: '美容外科产品设置'
                },
            },
            {
                path: '/setInject/newDiagnosis',
                name: 'injectDiagnosis',
                component: () => import('../views/setInject/newDiagnosis.vue'),
                meta: {
                    title: '美容外科诊断手术名称'
                },
            },
            {
                path: '/setInject/employee',
                name: 'setInjectEmployee',
                component: () => import('../views/setInject/employee.vue'),
                meta: {
                    title: '美容外科员工管理'
                },
            },
            {
                path: '/skinSet/setSkin',
                name: 'setSkin',
                component: () => import('../views/skinSet/setSkin.vue'),
                meta: {
                    title: '注射微整科手术设置'
                },
            },
            {
                path: '/skinSet/setProduction',
                name: 'setProduction',
                component: () => import('../views/skinSet/setProduction.vue'),
                meta: {
                    title: '注射微整科产品设置'
                },
            },
            {
                path: '/skinSet/newDiagnosis',
                name: 'newDiagnosis',
                component: () => import('../views/skinSet/newDiagnosis.vue'),
                meta: {
                    title: '注射微整科诊断手术名称'
                },
            },
            {
                path: '/skinSet/employee',
                name: 'skinSetEmployee',
                component: () => import('../views/skinSet/employee.vue'),
                meta: {
                    title: '注射微整科员工管理'
                },
            },
            {
                path: '/project/project',
                name: 'project',
                component: () => import('../views/project/project.vue'),
                meta: {
                    title: '项目管理'
                },
            },
            {
                path: '/material/material',
                name: 'material',
                component: () => import('../views/material/material.vue'),
                meta: {
                    title: '耗材管理'
                },
            },
            {
                path: '/yard/yard',
                name: 'yard',
                component: () => import('../views/yard/yard.vue'),
                meta: {
                    title: '院区管理'
                },
            },
            {
                path: '/inform/inform',
                name: 'inform',
                component: () => import('../views/inform/inform.vue'),
                meta: {
                    title: '信息来源'
                },
            },
            {
                path: '/card/card',
                name: 'card',
                component: () => import('../views/card/card.vue'),
                meta: {
                    title: '员工管理'
                },
            },
            {
                path: '/skin/skin',
                name: 'skin',
                component: () => import('../views/skin/skin.vue'),
                meta: {
                    title: '仪器管理'
                },
            },
            {
                path: '/case/case',
                name: 'case',
                component: () => import('../views/case/case.vue'),
                meta: {
                    title: '医务科电子病历'
                },
            },
            {
                path: '/department/department',
                name: 'department',
                component: () => import('../views/department/department.vue'),
                meta: {
                    title: '科室管理'
                },
            },
            {
                path: '/custom/customer/customer',
                name: 'customer',
                component: () => import('../views/custom/customer/customer.vue'),
                meta: {
                    title: '客户列表'
                },
            },
            {
                path: '/custom/order/list',
                name: 'orderList',
                component: () => import('../views/custom/order/list.vue'),
                meta: {
                    title: '购买'
                },
            },
            {
                path: '/custom/order/consumeList',
                name: 'consumeList',
                component: () => import('../views/custom/order/list.vue'),
                meta: {
                    title: '划扣'
                },
            },
            {
                path: '/custom/order/aaa',
                name: 'aaa',
                component: () => import('../views/custom/order/aaa.vue'),
                meta: {
                    title: 'aaa'
                },
            },
            {
                path: '/role/webUser',
                name: 'webUser',
                component: () => import('../views/role/webUser.vue'),
                meta: {
                    title: '后台用户'
                },
            },
            {
                path: '/role/roleManagement',
                name: 'roleManagement',
                component: () => import('../views/role/roleManagement.vue'),
                meta: {
                    title: '后台角色'
                },
            },
            {
                path: '/record/record',
                name: 'record',
                component: () => import('../views/record/record.vue'),
                meta: {
                    title: ''
                },
            },

            {
                path: '/observation/hand',
                name: 'hand',
                component: () => import('../views/observation/hand/hand.vue'),
                meta: {
                    title: '留观管理/交接'
                },
            },
            {
                path: '/observation/record',
                name: 'nursingRecord',
                component: () => import('../views/observation/record/record.vue'),
                meta: {
                    title: '护理记录单'
                },
            },
            {
                path: '/observation/temperature',
                name: 'temperature',
                component: () => import('../views/observation/temperature/temperature.vue'),
                meta: {
                    title: '体温单'
                },
            },
            {
                path: '/observation/sheetForm',
                name: 'sheetForm',
                component: () => import('../views/observation/sheetForm/order.vue'),
                meta: {
                    title: '临时医嘱单'
                },
            },
            {
                path: '/observation/sheet',
                name: 'orderSheet',
                component: () => import('../views/observation/sheet/order.vue'),
                meta: {
                    title: '长期医嘱单'
                },
            },
            {
                path: '/doctorTable/index',
                name: 'doctorTable',
                component: () => import('../views/doctorTable/index.vue'),
                meta: {
                    title: '医生业绩表'
                },
            },
        ]
    },

    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: () =>
            import('../views/login.vue'),
        name: 'login'
    },
]

const router = new VueRouter({
    routes,
    mode: 'hash'
})

export default router